import igv from 'igv';

var genomeBrowser;

// Once rendered DOM
$( document ).ready( function(){

	let session = getParameterByName( "session", null );

	if ( session ) {
		createBrowser( session, null );
	}


});

function createBrowser( session, maxrange ) {
	
	// We should retrive list of beds from session?
	$.get( "/list?session="+session, function( data ) {})
	.done(function( data ) {

		if ( data.hasOwnProperty( "files" ) ) {

			let chromsize = "1000000";
			if ( data.hasOwnProperty( "chromsize" ) ) {
				chromsize = data.chromsize;
			}

			let tracksArr = filterTracks( session, data.files );

			let options = {
				locus: "chr1:1-"+chromsize,

				reference: {
					id: "virtual",
					fastaURL: "/download?session="+session+"&filename=output/chr1.fa&out=chr1.fa",
					indexURL: "/download?session="+session+"&filename=output/chr1.fa.fai&out=chr1.fa.fai"
				},


				tracks: tracksArr
			};

			console.log( data );
			// Empty first just in case
			$("#igv").empty();
			igv.createBrowser( document.getElementById("igv"), options ).then( 
				function ( igvBrowser ) {
					genomeBrowser = igvBrowser;
					
					if ( maxrange ) {
						
						changeMaxRange( genomeBrowser, maxrange );
					}

				}
			);

		}

	});	
}


// On file upload
$( "input[name=trackfile]" ).change( function( event ){
	
	let input = $( this ).get( 0 );
	let session = getParameterByName( "session", null );

	if ( session && input ) {
		handleNewTrackFile( input, session );
	}
	
});

// On data range change
$( "input[name=maxrange]" ).on( "input", function( event ){
		
	let maxrange = $( this ).val();
	
	changeMaxRange( genomeBrowser, maxrange );
	
});

function changeMaxRange( genomeBrowser, maxrange ) {
	
	if ( maxrange && maxrange !== "" ) {

		let n = 0;
		genomeBrowser.trackViews.forEach( function( trackview ) {
			if ( trackview.hasOwnProperty("track") ) {
				if ( trackview.track.hasOwnProperty("dataRange") ) {
					genomeBrowser.trackViews[n].setDataRange( 0, parseFloat( maxrange ) );
				}
			}
			
			n++;
		});
	
	}
	
}


// On file upload
$( "input[name=uploadfile]" ).change( function( event ){
	
	let input = $( this ).get( 0 );
	// Need to generate session
	
	if ( input ) {
		handleNewTrackFile( input, null );
	}
	
});


function handleNewTrackFile( input, session=null ) {
	
	if ( input && input.files ) {
		
		if ( input.files.length > 0 ) {
			
			let infiles = input.files;
			
			uploadFileToSession( infiles, session );
			
		}
			
	}
}

function uploadFileToSession( infiles, session=null ) {
	
		let formData = new FormData();

		if ( session ) {
			formData.append( "session", session );
		}
		
		for( let x=0; x < infiles.length; x++ ){
		
			formData.append( "trackfile[]", infiles[x], infiles[x].filename );
		}
		
		let exec = "/upload";

		$.ajax({
			url : exec,
			type: "POST",
			data : formData,
			processData: false,
			contentType: false,
				success:function(data, textStatus, jqXHR){
		
					if ( data && data.session ) {
						
						// Handle different way depending existing session or not
						
						if ( session ) {
							
								let maxrange = $( "input[name=maxrange]" ).val();

								createBrowser( session, maxrange );
								
						} else {
						
							window.location.replace("/results?session="+data.session);
						}
					}
		
				},
				error: function(jqXHR, textStatus, errorThrown){
					//if fails
					
					// TODO: To be handled
				}
		});
}


// Once loaded libraries -> Not needed with locus change, even with first it works
//$(window).on('load', function () {
//
//	if ( igvBrowser.hasOwnProperty( 'config' ) ) {
//		if ( igvBrowser.config.hasOwnProperty( 'locus' ) ) {
//			console.log( igvBrowser.config.locus );
//		}
//	}
//});

function filterTracks( session, data ) {

	let tracksArr = [];

	// TODO: Consider what to do with bed + bedGraph

	// We pass data sorted
	for ( let file of data.sort() ) {

		let addtrack = 0;

		if ( file.endsWith(".bed") || file.endsWith(".gff") || file.endsWith(".bedGraph") || file.endsWith('.bw') ) {

			addtrack = 1;
			let displayMode = "COLLAPSED";

			let filetype = "annotation";
			let fileformat = "bed";

			if ( file.endsWith(".gff") ) {
				fileformat = "gff3";
			}

			if ( file.endsWith(".bedGraph") ) {
				filetype = "wig";
				fileformat = "bedGraph";
			}

			if ( file.endsWith(".bw") ) {
				filetype = "wig";
				fileformat = "bigWig";	
			}
			
			let urlfile = "/download?session="+session+"&format="+fileformat+"&filename=output/"+file+"&out="+file;
	
			let track = {

				name : file,
				type: filetype, //TODO: Depending type, https://github.com/igvteam/igv.js/wiki/Tracks
				format: fileformat,
				displayMode: displayMode,
				url: urlfile

			};
			
			// console.log( track );

			// TODO: Check if bed index -> then add it...

			tracksArr.push( track );
		}

	}

	return tracksArr;

}


function getParameterByName( name, url) {

	if (!url) url = window.location.href;

	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));

}



// WEBPACK FOOTER //
// ./assets/js/results.js